import './config';
import {apiBaseUrl} from './config';
import {getBaseHeader} from './utils';
import SfpBaseService from './sfp-base-service';

const PPI_REVENUES = 'ppis/revenues';

export default class PPIRevenueService extends SfpBaseService {

  static createPPIRevenue(ppi_revenue) {
    const body = JSON.stringify({ppi_revenue});
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${PPI_REVENUES}`, {body, headers, method: "POST"})
      .then(super.returnResponse);
  }

  static updatePPIRevenue(ppi_revenue_id, ppi_revenue) {
    const body = JSON.stringify({ppi_revenue});
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/ppis/${ppi_revenue_id}/revenue`, {body, headers, method: "PUT"})
      .then(super.returnResponse);
  }

  static deletePPIRevenue(ppi_revenue) {
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/ppis/${ppi_revenue.id}/revenue`, {headers, method: "DELETE"})
      .then(super.returnResponse);
  }

}



// WEBPACK FOOTER //
// ./src/service/sfp/ppi-revenue-service.js